<div class="inner-page-bg-right">
  <header data-aos="zoom-in" class="aos-init aos-animate">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="inner-header">
            <div class="logo">
              <a href="javascript:void();" [routerLink]="'/login'"> <img src="./assets/images/logo-inner.png" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="banner-inner-pages">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="banner-left-text mb-4">
            <h4>Invitation from <b>{{model?.campaignDetail?.organizationName}}</b> for <b>{{model?.storeDetail?.name}}</b> to Redeem Coupons.</h4>
            <h6>Campaign details below:</h6>
          </div>
        </div>
        <div class="col-sm-4">
          <img class="img img-responsive m-1 col-sm-12" alt="image" [src]="model?.campaignDetail?.productDetails[0]?.image_url">
          <h1 class="text-center">{{model?.campaignDetail?.productDetails[0]?.name}}</h1>
        </div>
        <div class="col-sm-1"></div>
        <div class="col-sm-7 campaign-detail">
          <h1 class="mb-4">{{model?.campaignDetail?.offerTypeTitle}}</h1>
          <p>{{model?.campaignDetail?.campaignName}}</p>
          <p>{{model?.campaignDetail?.offerDescription}}</p>
          <p><b>Code : </b> <span>{{model?.campaignDetail?.couponCode}}</span></p>
          <p><mat-icon> local_offer</mat-icon> {{model?.campaignDetail?.couponTypeName}}</p>
          <p><mat-icon> location_on</mat-icon> Offer available in {{model?.campaignDetail?.location}}</p>
          <p><mat-icon> date_range</mat-icon> Expires on {{model?.campaignDetail?.endDate | date :'dd MMM yyyy'}}</p>
          <p *ngIf="model?.campaignDetail?.isRequiredTime">
            <mat-icon> access_time</mat-icon>
            Coupon Valid Time
            {{model?.campaignDetail?.startDateTime}} to {{model?.campaignDetail?.endDateTime}}
          </p>
          <p><mat-icon> event_available</mat-icon> Valid on:
            <span *ngIf="model?.campaignDetail?.validDays?.length >= 7">
              <span> All Days</span>
            </span>
            <span *ngIf="model?.campaignDetail?.validDays?.length < 7">
              <span *ngIf="validDays.includes('7')"> Sun</span>
              <span *ngIf="validDays.includes('1')"> Mon</span>
              <span *ngIf="validDays.includes('2')"> Tue</span>
              <span *ngIf="validDays.includes('3')"> Wed</span>
              <span *ngIf="validDays.includes('4')"> Thu</span>
              <span *ngIf="validDays.includes('5')"> Fri</span>
              <span *ngIf="validDays.includes('6')"> Sat</span>
            </span>
          </p>

          <div class="row" *ngIf="this.model?.campaignDetail?.offerType == 'BUYGET'">
            <p>Free Product/s</p>

            <div class="col-sm-3" *ngFor="let freeProduct of this.model?.campaignDetail?.freeProductDetails">
              <img class="img img-responsive img-thumbnail m-1 col-sm-12" alt="image"
                [src]="freeProduct.image_url">
            </div>
          </div>

          <button type="submit" mat-raised-button (click)="onClickConfirm()" color="primary">Accept</button>
        </div>
      </div>
    </div>
  </section>
</div>
<app-admin-footer></app-admin-footer>